import { render, staticRenderFns } from "./AxisSidebar.vue?vue&type=template&id=2a38baa0&"
import script from "./AxisSidebar.vue?vue&type=script&lang=js&"
export * from "./AxisSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports